import { assign, groupBy } from 'lodash';
import { ActionType } from '../actions/actions';
import { IAction } from '../../classes/action';
import { Production } from '../../classes/production';
import { Series } from '../../classes/series';
import { Day } from '../../classes/day';

export interface FestivalOverviewApiModel {
    requestingData: boolean;
    seriesList: Series[];
    currentDay: string;
    dayLabel: string;
    noSeries: boolean;
    requestingSettings: boolean;
}

export const defaultFestivalOverviewAppModel: FestivalOverviewApiModel = {
    requestingData: true,
    currentDay: "",
    dayLabel: "",
    noSeries: false,
    requestingSettings: false,
    seriesList: []
};

export default function festivalOverviewApiReducer(state: FestivalOverviewApiModel = defaultFestivalOverviewAppModel, action: IAction) {
    switch (action.type) {
        case ActionType.REQUEST_NEXT_BATCH: {
            return assign({}, state, { requestingData: true });
        }
        case ActionType.RECEIVE_NEXT_BATCH: {
            const seriesList = action.value.seriesList;
            const currentDay = action.value.currentDay;
            const dayLabel = action.value.dayLabel;

            const noSeries = seriesList.length == 0 ? true : false;

            return assign({}, state, { seriesList: seriesList, dayLabel: dayLabel, currentDay: currentDay, requestingData: false, noSeries: noSeries })
        }
        default:
            return state;
    }
}